module.exports = "/img/_/_/_/assets/images/avatar/portrait/male//warrior.png?479d7eeaf0240a8c4f546afbbb4ff9d7";